const logo = require('theme/assets/logo.png');
const intelsect = require('theme/assets/intelsect_logo.png');

export default () => {
  var full = window.location.host;
  var parts = full.split('.');
  var subdomain = parts[0];
  if (subdomain === 'intelsect') {
    return intelsect;
  }
  return logo;
};
